module.exports = __webpack_public_path__ + "img/banner6.59e378cd.png";